module.exports = __webpack_public_path__ + "img/workshop-banner-1.35b25d51.jpg";